<button type="button" class="page-toolbar-search-action column-picker__trigger"
        [class.page-toolbar-search-action--active]="open"
        (click)="toggleOpen($event)" title="Columns" aria-haspopup="true" [attr.aria-expanded]="open">
  <!-- Three columns. -->
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
       stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
    <rect x="3" y="4" width="18" height="16" rx="2"/><path d="M9 4v16M15 4v16"/>
  </svg>
</button>

<div class="column-picker__menu" *ngIf="open" role="menu" (click)="$event.stopPropagation()">
  <div class="column-picker__caption">Columns</div>
  <label class="column-picker__item" *ngFor="let column of columns; trackBy: trackByKey">
    <input type="checkbox" [checked]="isVisible(column.key)" (change)="onToggle(column, $event)" />
    <span>{{ column.label }}</span>
  </label>
</div>
